import { IBaseResponse } from "@carm/_utils/models";

export interface ICadDocumentJobStatusResponse extends IBaseResponse {
  jobStatus: AsyncDocumentJobStatus;
}

export interface ICadShouldUseAsyncResponse extends IBaseResponse {
  shouldUseAsync: boolean;
}

export interface IStartJobResponse extends IBaseResponse {
  jobId: string;
}

export enum AsyncDocumentJobStatus {
  //done
  Finished = 'F',

  //error
  Cancelled = 'A',
  Error = 'E',

  //running
  Released = 'S',
  Active = 'R',
  Ready = 'Y',
  Scheduled = 'P',
  ReleasedScheduled = 'Z'
}
